import { A } from "@solidjs/router";
import { JSX, Show } from "solid-js";
import { useBrandl2WebstoreTelescopeContext } from "../context/brandl2_webstore_telescope_context";
import { getCategorySlugFromCategoryName } from "~/utils/common";

/**
 * Breadcrumbs navigation section
 * Format: HOME > CATEGORY > BRAND
 * Hidden on mobile, visible on desktop (lg:flex)
 */
export function BreadcrumbsSection(): JSX.Element {
  const { routeData } = useBrandl2WebstoreTelescopeContext();

  const brandName = () => routeData().brand.name;
  const categoryName = () => routeData().brandExtraMetadata?.categoryTitle;
  const categorySlug = () =>
    getCategorySlugFromCategoryName(
      routeData().brandExtraMetadata?.categoryName ?? ""
    );

  return (
    <nav class="w-full" aria-label="Breadcrumb">
      <ol class="flex items-center gap-2 text-para-3-medium text-text-normal-secondary">
        <li>
          <A href="/" class="hover:text-text-normal-primary hover:underline">
            Home
          </A>
        </li>
        <li>
          <ChevronRightIcon />
        </li>
        <Show when={categoryName()}>
          <li>
            <A
              href={`/shop-by-category/${categorySlug()}`}
              class="hover:text-text-normal-primary hover:underline"
            >
              {categoryName()}
            </A>
          </li>
          <li>
            <ChevronRightIcon />
          </li>
        </Show>
        <li class="text-text-normal-primary">{brandName()}</li>
      </ol>
    </nav>
  );
}

function ChevronRightIcon(): JSX.Element {
  return (
    <svg
      class="size-4 text-text-normal-tertiary"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 12L10 8L6 4"
        stroke="currentColor"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
